'use client';

// This component is now deprecated - all functionality moved to SuperAdminDebugControls
export function SuperAdminIndicator() {
  return null;
}